module.exports = __webpack_public_path__ + "Journal Regular.42f9b17bffb14d4331ed.eot";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/fonts/Journal Regular.eot
// module id = ../../../../../src/fonts/Journal Regular.eot
// module chunks = styles